var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "confirm-modal",
    {
      ref: "modal",
      attrs: {
        title: "Удаление адреса",
        confirm: "Удалить",
        reset: "Отменить",
        mode: "danger",
        modal: true,
      },
    },
    [
      _vm.busy
        ? _c("Loader", {
            staticClass: "loader",
            attrs: { label: "Данные загружаются", height: "120", active: true },
          })
        : _vm.data
        ? [
            _vm._v(" Адрес "),
            _vm.data.type === "address"
              ? _c("strong", [
                  _vm._v(
                    " " +
                      _vm._s(
                        [
                          _vm.data.address.city,
                          _vm.data.address.street,
                          _vm.data.address.home,
                          _vm.data.address.housing,
                        ]
                          .filter(Boolean)
                          .join(", ")
                      ) +
                      " "
                  ),
                ])
              : _c("span", [
                  _c("strong", [
                    _vm._v(" " + _vm._s(_vm.data.zone.name) + " "),
                  ]),
                  _vm._v(" ("),
                  _c(
                    "a",
                    { attrs: { href: _vm.data.zone.url, target: "_blank" } },
                    [_vm._v(" " + _vm._s(_vm.data.zone.url) + " ")]
                  ),
                  _vm._v(") "),
                ]),
            _vm._v(" будет удален без возможности восстановления "),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }